module.exports = __webpack_public_path__ + "img/64686F_BDC0C4_161718_A4A7AB-256px.f113b95c.png";